<template>
  <footer class="footer">
    <iframe
      id="footer"
      :src="standaloneFooterUrl"
      width="100%"
      height="58px"
      seamless="seamless"
      frameborder="0"
      scrolling="no"></iframe>
  </footer>
</template>
<script>

export default {
  name: 'global-footer',
  data: function () {
    return {
      standaloneFooterUrl: dconf.GLOBAL_STANDALONE_FOOTER_URL
    };
  },
  mounted() {
    if (appEnv !== 'dev') {
      this.standaloneFooterUrl = `${this.publication.zephrCDN}${this.standaloneFooterUrl}`;
    }
    console.log(`Footer url: ${this.standaloneFooterUrl}`);
    const app = this;
    function eventHandler(event) {
      if (event && event.data) {
        const data = event.data;
        if (data['footer-height'] !== undefined) {
          app.setHeight(data);
        }
      }
    }

    if (window.addEventListener) {
      window.addEventListener('message', eventHandler, false);
    } else {
      window.attachEvent('onmessage', eventHandler);
    }
  },
  methods: {
    setHeight(data) {
      const height = data['footer-height'];
      const footer = document.getElementById('footer');
      footer.setAttribute('height', height);
    }
  }
};
</script>
